import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, colors } = useTheme();
  return {
    listWrapper: css`
      width: 100%;
    `,
    chooseFilter: isSelected => css`
      position: relative; // Needed for positioning the visually-hidden input
      display: flex;
      justify-content: space-between;
      gap: 1rem;
      align-items: center;
      padding: 8px 8px 8px 12px;
      border-radius: 80px;
      margin-bottom: 0.25rem;
      cursor: pointer; // Indicates the label is clickable

      span {
        color: #5b6885;
        letter-spacing: 0.32px;
      }
      &:hover {
        //outline: none;
        background-color: #eceef3;
      }

      // Use :focus-within to style the parent label when the checkbox is focused
      &:focus-within {
        // background-color: #eceef3;
        //outline: 2px solid #00539f; // Visual focus indicator
        //outline-offset: 2px;
      }
      ${breakpoints.s} {
        &:has(input:focus-visible) {
          border: 2px solid ${colors.border_black};
          outline: 2px solid ${colors.skip_yellow};
        }
      }

      ${isSelected &&
      css`
        background-color: #eceef3;
      `}
    `,
    optionCheckbox: css`
      // Visually hide the native checkbox but keep it accessible
      position: absolute;
      opacity: 0;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border-width: 0;

      // Style the checkmark's parent container
      & + span {
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 100%;
        color: #5b6885;
        border: 2px solid currentColor;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      // Style the checked state of the visual checkbox
      &:checked + span {
        color: #00539f;
        background-color: #fff;
      }

      // Style the visual checkmark via a pseudo-element on the adjacent span
      &:checked + span::after {
        content: '';
        width: 0.25rem;
        height: 0.625rem;
        border: solid currentColor;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
        position: relative;
        display: block; // Make the checkmark visible when checked
        margin-top: -3px;
      }
    `,
    divider: css`
      display: flex;
      align-items: center;
      justify-content: center;
      color: #5b6885;
      position: relative;
      margin-bottom: 4px;
      padding: 8px 0;

      /* FDS Mobile/Body/Body medium */
      font-family: 'FS Dillon';
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0.32px;

      &::before,
      &::after {
        content: '';
        flex: 1;
        height: 1px;
        background: #e4e7ec;
        margin: 0 8px;
      }
    `,
  };
};
